import { render } from "./ComboAplicacaoRegraPreco.vue?vue&type=template&id=d8a2b0de&ts=true"
import script from "./ComboAplicacaoRegraPreco.vue?vue&type=script&lang=ts"
export * from "./ComboAplicacaoRegraPreco.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\OnSeller\\FrontEnd\\Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__